import React, { useState, useEffect } from 'react';

const DieterRamsClock = () => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const formatDate = (date) => {
        const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        return {
            day: days[date.getDay()],
            date: date.getDate(),
        };
    };

    const dateInfo = formatDate(time);

    // Format time as HH:MM (12-hour)
    let hours = time.getHours();
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutes = time.getMinutes().toString().padStart(2, '0');

    return (
        <div className="fixed top-6 right-6 flex items-center gap-3 z-40 select-none pointer-events-none font-sans mix-blend-multiply">
            {/* Date Display - Subtle, left of the clock */}
            <div className="flex items-center gap-1.5 text-[#AF2E1B] opacity-80 drop-shadow-[0_0_2px_rgba(175,46,27,0.3)]">
                <span className="text-[9px] font-bold tracking-[0.1em] uppercase">
                    {dateInfo.day}
                </span>
                <span className="text-[11px] font-bold tracking-tighter">
                    {dateInfo.date}
                </span>
            </div>

            {/* Digital Clock - Glowing Orange Text */}
            <div className="flex items-baseline gap-0.5">
                <span className="font-mono text-lg font-bold tracking-widest text-[#AF2E1B] drop-shadow-[0_0_8px_rgba(175,46,27,0.6)] leading-none" style={{ fontFamily: '"Courier New", monospace' }}>
                    {hours}<span className="animate-pulse">:</span>{minutes}
                </span>
            </div>
        </div>
    );
};

export default DieterRamsClock;
